module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-White.874b30a1.svg";